<template>
  <v-card :class="[$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']">
      <v-toolbar dark color="primary" class="fullToolbar">
        <v-toolbar-title class="white--text" style="font-size: 30px; text-align: right;">
          <i class="material-icons icon">assignment</i>יומנים
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field v-if="!$root.device.isMobile" dark prepend-icon="search" single-line style="padding-top: 20px;" v-model="txtSearch"></v-text-field>
        <v-icon v-else @click="$root.activeMobileMenu=true" class="btnIcon mr-2 ml-2">menu</v-icon>
      </v-toolbar>
      <div style="width: 100%;">
        <div style="text-align: right;">
          <v-icon v-if="$root.isCustomer || $root.isAdmin" @click="addNew" class="btnAdd" v-tooltip:left="{ html: 'הוסף חדש' }">add</v-icon>
          <!--<div id="printBtn"></div>-->
          <span v-if="$root.isCustomer" style="padding-right: 10px;padding-left: 10px;">סה"כ יומנים בחשבון</span><b v-if="$root.isCustomer" style="padding-left: 10px;">{{$root.user.TotalDiaries}}</b>
          <span v-if="$root.isCustomer">/</span>
          <span v-if="$root.isCustomer" style="padding-right: 10px;padding-left: 10px;">סה"כ יומנים בשימוש</span><b v-if="$root.isCustomer" style="padding-left: 10px;">{{usedDiaries}}</b>
        </div>
        <table v-if="$root.isAdmin" class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable" style="padding: 20px!important; border:none; width: 100%;">
          <tr class="trPrint trHeader">
            <th class="tdData sp">כותרת</th>
            <th class="tdData">לקוח</th>
            <th class="tdData">פרויקט</th>
            <th class="tdData" v-if="!$root.device.isMobile">תאריך יצירה</th>
            <th class="tdData">תאריך עדכון</th>
            <th class="tdCtrl" style="width: 160px!important;"></th>
          </tr>
        </table>
        <div v-if="$root.isAdmin && hasData" class="scrollContent">
          <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1" style="border:none;">
            <tr v-for="row in filteredRows">
              <td class="tdData sp">{{row.Title}}</td>
              <td class="tdData tdTxt">{{row.CustomerName}}</td>
              <td class="tdData tdTxt">{{row.ProjectName}}</td>
              <td class="tdData tdTxt" v-if="!$root.device.isMobile">{{row.CreateDate}}</td>
              <td class="tdData tdTxt">{{row.UpdateDate}}</td>
              <td class="tdCtrl tdTxt" style="width: 160px!important;">
                <v-icon @click="open(row)" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'פתח יומן' }">reply_all</v-icon>
                <v-icon @click="edit(row)" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'עריכה' }">border_color</v-icon>
                <v-icon @click="confirm(row)" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'מחיקה' }">delete</v-icon>
              </td>
            </tr>
          </table>
        </div>
        <div v-if="!$root.isAdmin && hasData" :class="[$root.device.isMobile ? 'scrollContentMobile' : 'scrollContent']">
          <v-card :class="['cardDiary', $root.device.isMobile ? 'cardDiaryMobile' : '']" v-for="row in filteredRows">
            <v-container grid-list-lg :style="{ 'background-color': row.Color }">
              <v-layout row>
                <v-flex xs5>
                  <img :src="row.Image" />
                </v-flex>
                <v-flex xs7>
                  <div style="padding-right: 10px;">
                    <div style="text-align: right;"><b>{{shortString(row.Title, 15)}}</b></div>
                    <div style="text-align: right;">{{shortString(row.ProjectName, 15)}}</div>
                    <div style="text-align: right;">{{row.Status['Name']}}</div>
                    <div style="text-align: right;">{{row.CreateDate}}</div>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row style="padding-left: 20px;">
                <v-flex xs12>
                  <div style="text-align: right; font-size: 12px;">{{shortString(row.Info, 30)}}</div>
                </v-flex>
              </v-layout>
              <v-layout row style="padding-left: 20px;">
                <v-flex xs6>
                  <div @click="open(row)" class="btnPlans" style="margin: 0px;">
                    <v-layout>
                      <v-flex xs1>
                      </v-flex>
                      <v-flex xs2>
                        <i class="material-icons icon">reply_all</i>
                      </v-flex>
                      <v-flex xs8>
                        <div style="font-weight: bold;">פתח יומן</div>
                      </v-flex>
                      <v-flex xs1>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
                <v-flex xs4>
                </v-flex>
                <v-flex xs1 v-if="$root.isCustomer">
                  <v-icon @click="edit(row)" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'עריכה' }">border_color</v-icon>
                </v-flex>
                <v-flex xs1 v-if="$root.isCustomer">
                  <v-icon @click="confirm(row)" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'מחיקה' }">delete</v-icon>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>

        </div>
        <div fluid v-if="!hasData && !isLoading">
          <h3 style="padding-top: 40px;">אין נתונים</h3>
        </div>
        <div fluid v-if="isLoading" style="padding-top: 50px; color: #aaa;">
          <v-progress-circular indeterminate :size="50"></v-progress-circular>
        </div>
        <PopupDiary></PopupDiary>
      </div>
    </v-card>
</template>

<script>

  import { db } from '../firebase';
  var diariesRef = db.ref('Diaries');
  var diariesUsersRef = db.ref('Diaries');
  var customersRef = db.ref('Customers');
  var statusesRef = db.ref('Statuses');
  var projectsRef = db.ref('Projects');
  var messagesRef = db.ref('Messages');

  import PopupDiary from '../components/PopupDiary';
  import noImg from '../assets/no_image.png';

  export default {
    name: 'Diaries',
    components: { PopupDiary },
    data() {
      return {
        txtSearch: '',
        isLoading: false,
        diaries: [],
        isActiveUsers: false,
        popup: {
          isVisible: false,
          isEdit: false,
          title: '',
          data: {
            '.key': '', Title: '',
            CustomerName: '',
            CustomerKey: '',
            ProjectName: '',
            ProjectKey: '',
            CreateDate: '',
            UpdateDate: '',
            SendToCustomer: false,
            SendToInspectors: false,
            SendToContractors: false,
            Info: '',
            AddedUsers: null
          },
        }
      }
    },
    firebase: function () {
      var vm = this;
      return {
        //messages: messagesRef.orderByChild("ToUserKey").equalTo(vm.$root.user['.key']),
        //diaries: diariesRef.orderByKey(),
        statuses: statusesRef.orderByKey()
      }
    },
    created() {
      this.$Log("Vue [Diaries] is created ...");
    },
    ready() {
      this.$Log("Vue [Diaries] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Diaries] is mounted ...");
      this.loadDiaries();
    },
    updated() {
      this.$Log("Vue [Diaries] is updated ...");
    },
    computed: {
      hasData() {
        return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
      },
      usedDiaries() {
        return this.diaries.length;
      },
      filteredRows() {
        var vm = this;
        if (vm.txtSearch.length > 0) {
          var result = [];
          try {
            result = vm.diaries.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                  return row;
                }
              })
            });
          }
          catch (e) {
          }
        }
        else {
          result = vm.diaries;
        }

        return result;
      }
    },
    watch: {
      diaries(val) {
        this.$forceUpdate();
      },
      '$root.confirm.isConfirmed'(val) {
        if (val && this.$root.confirm.caller == 'RemoveDiary') {
          this.remove();
        }
      }
    },
    methods: {
      shortString(str, len) {
        if (str.length > len) {
          return str.substring(0, len) + '...';
        }
        else {
          return str;
        }
      },
      //showProjectName(row)row.ProjectName
      //showTitle(row) {
      //  if (row.Title.length > 15) {
      //    return row.Title.substring(0, 15) + '...';
      //  }
      //  else {
      //    return row.Title;
      //  }
      //},
      //showInfo(row) {
      //  //showTitle(row)row.Title
      //  if (row.Info.length > 10) {
      //    return row.Info.substring(0, 10) + '...';
      //  }
      //  else {
      //    return row.Info;
      //  }
      //},
      getHref(row) {
        return '#/Diary/' + row['.key'];
      },
      loadDiaries() {
        var vm = this;

        vm.isLoading = true;

        if (vm.$root.isAdmin) {
          vm.loadAllDiaries();
        }
        if (vm.$root.isCustomer) {
          vm.loadCustDiaries();
        }
        else {
          vm.loadMyDiaries();
        }
      },
      loadAllDiaries() {
        this.$Log("Vue [Diaries] loadAllDiaries() ...");
        var vm = this;
        vm.diaries = [];
        diariesRef.orderByKey().once('value').then(function (snapshot) {
          console.log(JSON.stringify(snapshot.val()));
          let obj = snapshot.val();
          if (obj) {
            let keys = Object.keys(obj);
            for (var i = 0; i < keys.length; i++) {
              let key = keys[i];
              let diary = obj[key];
              diary['.key'] = key;
              vm.diaries.push(diary);
            }
          }
          vm.isLoading = false;
        });
      },
      loadCustDiaries() {
        this.$Log("Vue [Diaries] loadCustDiaries() ...");
        var vm = this;
        vm.diaries = [];
        console.log("vm.$root.user['.key']  >>> " + vm.$root.user['.key']);
        diariesRef.orderByChild('CustomerKey').equalTo(vm.$root.user['.key']).once('value').then(function (snapshot) {
          console.log(JSON.stringify(snapshot.val()));
          let obj = snapshot.val();
          if (obj) {
            let keys = Object.keys(obj);
            for (var i = 0; i < keys.length; i++) {
              let key = keys[i];
              let diary = obj[key];
              diary['.key'] = key;

              let found = projectsRef.orderByKey().equalTo(diary.ProjectKey).once('value').then(function (snapshotProj) {
                let objProj = snapshotProj.val();
                if (objProj) {
                  let keyP = Object.keys(objProj)[0];
                  let proj = objProj[keyP];
                  console.log(JSON.stringify(diary))
                  if (proj.Images && proj.Images.length > 0) {
                    diary.Image = proj.Images[0];
                  }
                  else {
                    diary.Image = noImg;
                  }
                  console.log(JSON.stringify(diary))
                  let status = vm.statuses.filter(function (st) {
                    if (st['.key'] == proj.StatusKey) {
                      diary.Status = st;
                      diary.Color = st.Color;
                      //alert(JSON.stringify(row))
                      //result.push(row[rowKey]);
                      //result.push(row);
                      vm.diaries.push(diary);
                      return true;
                    }
                  });
                  // alert(JSON.stringify(status))
                  //alert(JSON.stringify(row))
                  return true;
                }
                else {
                  return false;
                }
              });
            }
          }
          vm.isLoading = false;
        });
      },
      loadMyDiaries() {
        this.$Log("Vue [Diaries] loadMyDiaries() ...");
        var vm = this;
        vm.diaries = [];

        console.log("vm.$root.user['.key']  >>> " + vm.$root.user['.key']);
        messagesRef.orderByChild("ToUserKey").equalTo(vm.$root.user['.key']).once('value').then(function (snapshotMsg) {
          console.log(JSON.stringify(snapshotMsg.val()));
          let objMsg = snapshotMsg.val();
          if (objMsg) {
            let msgKeys = Object.keys(objMsg);
            for (var j = 0; j < msgKeys.length; j++) {
              let mk = msgKeys[j];
              let msg = objMsg[mk];
              if (msg.IsConfirmed) {
                console.log("[MSG]  >>> " + JSON.stringify(msg));
                console.log("[MSG]  DiaryKey>>> " + msg.DiaryKey);
                diariesRef.orderByKey().equalTo(msg.DiaryKey).once('value').then(function (snapshot) {
                  console.log("Diary >>>>>>>>>>>>>>>>>>>>>>");
                  console.log(JSON.stringify(snapshot.val()));
                  let obj = snapshot.val();
                  if (obj) {
                    let keys = Object.keys(obj);
                    for (var i = 0; i < keys.length; i++) {
                      let key = keys[i];
                      let diary = obj[key];
                      diary['.key'] = key;
                      
                      console.log("ProjectKey >>>>>>>> " + diary.ProjectKey);

                      let found = projectsRef.orderByKey().equalTo(diary.ProjectKey).once('value').then(function (snapshotProj) {
                        let objProj = snapshotProj.val();
                        if (objProj) {
                          let keyP = Object.keys(objProj)[0];
                          let proj = objProj[keyP];
                          //console.log(JSON.stringify(diary))
                          //diary.Image = proj.Images[0];
                          if (proj.Images && proj.Images.length > 0) {
                            diary.Image = proj.Images[0];
                          }
                          else {
                            diary.Image = noImg;
                          }
                          //console.log(JSON.stringify(diary))
                          let status = vm.statuses.filter(function (st) {
                            if (st['.key'] == proj.StatusKey) {
                              diary.Status = st;
                              diary.Color = st.Color;
                              //alert(JSON.stringify(row))
                              //result.push(row[rowKey]);
                              //result.push(row);
                              vm.diaries.push(diary);
                              return true;
                            }
                          });
                          // alert(JSON.stringify(status))
                          //alert(JSON.stringify(row))
                          return true;
                        }
                        else {
                          return false;
                        }
                      });
                    }
                  }
                });
              }
            }
          }
          vm.isLoading = false;
        });
      },
      addNew() {
        if (this.$root.isCustomer) {
          if (this.$root.user.TotalDiaries <= 0) {
            this.$root.alert = { isShow: true, message: 'אין חבילות/יומנים בחשבונך!', timeout: 3000, isTop: true }
            return;
          }

          if (this.$root.user.TotalDiaries == this.usedDiaries) {
            this.$root.alert = { isShow: true, message: 'כל היומנים בשימוש!', timeout: 3000, isTop: true }
            return;
          }
        }

        //usedDiaries

        this.popup = {
          isVisible: true,
          isEdit: false,
          title: 'יומן חדש',
          data: {
            '.key': '', Title: '',
            CustomerName: this.$root.user.FullName,
            CustomerKey: this.$root.user['.key'],
            ProjectName: '',
            ProjectKey: '',
            CreateDate: '',
            UpdateDate: '',
            SendToCustomer: false,
            SendToInspectors: false,
            SendToContractors: false,
            Info: '',
            AddedUsers: null
          },
        };
      },
      open(row) {
        if (this.$root.device.isMobile || this.$root.device.isTablet) {
          this.$router.push({ name: 'Diary', params: { diaryKey: row['.key'] } });
        }
        else {
          let routeData = this.$router.resolve({ name: 'Diary', params: { diaryKey: row['.key'] } });
          window.open(routeData.href, '_blank');
        }
      },
      edit(row) {
        this.popup = {
          isVisible: true,
          isEdit: true,
          title: 'עריכת יומן',
          data: {
            '.key': row['.key'],
            Title: row.Title,
            CustomerName: row.CustomerName,
            CustomerKey: row.CustomerKey,
            ProjectName: row.ProjectName,
            ProjectKey: row.ProjectKey,
            CreateDate: row.CreateDate,
            UpdateDate: this.$moment().format('DD/MM/YYYY'),
            Info: row.Info,
            SendToCustomer: row.SendToCustomer,
            SendToInspectors: row.SendToInspectors,
            SendToContractors: row.SendToContractors,
            AddedUsers: row.AddedUsers,
            Pages: row.Pages
          },
        };

        console.log(JSON.stringify(row))
      },
      confirm(row) {
        this.popup.data = row;
        this.$root.confirm = {
          isVisible: true,
          title: 'מחיקה',
          question: 'האם אתה בטוח ברצונך למחוק יומן זה?' + '<br/><p style="color:red;">* מחיקת יומן תמחק גם את ההערות שלו!</p>',
          caller: 'RemoveDiary',
          isConfirmed: false
        }
      },
      remove() {
        var vm = this;
        diariesRef.child(vm.popup.data['.key']).remove().then((snap) => {
          vm.loadDiaries();
        });
      },
      insert() {
        var vm = this;
        if (vm.popup.data.AddedUsers == undefined) {
          vm.popup.data.AddedUsers = null;
        }

        var item = {
          Title: vm.popup.data.Title,
          CustomerName: vm.popup.data.CustomerName,
          CustomerKey: vm.popup.data.CustomerKey,
          ProjectName: vm.popup.data.ProjectName,
          ProjectKey: vm.popup.data.ProjectKey,
          CreateDate: vm.$moment().format('DD/MM/YYYY'),
          UpdateDate: vm.$moment().format('DD/MM/YYYY'),
          Info: vm.popup.data.Info,
          SendToCustomer: vm.popup.data.SendToCustomer,
          SendToInspectors: vm.popup.data.SendToInspectors,
          SendToContractors: vm.popup.data.SendToContractors,
          AddedUsers: vm.popup.data.AddedUsers,
        };

        //var newDiary = diariesRef.push(item);
        //var newID = newDiary.name();

        diariesRef.push(item).then((snap) => {
          const diaryKey = snap.key;
          //if (item.AddedUsers && item.AddedUsers.length > 0) {
          if (item.AddedUsers) {
            var keys = Object.keys(item.AddedUsers);
            for (var u = 0; u < keys.length; u++) {
              let key = keys[u];
              let user = item.AddedUsers[key]
              if (!user.IsConfirmed) {
                var msg = {
                  CreateDate: vm.$moment().format('DD/MM/YYYY'),
                  DiaryKey: diaryKey,
                  IsConfirmed: false,
                  SenderName: vm.$root.user.FullName,
                  SenderKey: vm.$root.user['.key'],
                  Text: vm.$root.user.FullName + ' מבקש לצרף אותך ליומן',
                  ToUserKey: user.UserKey,
                  Type: 'אישור',
                }
                messagesRef.push(msg);
              }
            }
          }

          vm.loadDiaries();
        });
      },
      update() {
        var vm = this;
        if (vm.popup.data.AddedUsers == undefined) {
          vm.popup.data.AddedUsers = null;
        }
        
        var item = {
          Title: vm.popup.data.Title,
          CustomerName: vm.popup.data.CustomerName,
          CustomerKey: vm.popup.data.CustomerKey,
          ProjectName: vm.popup.data.ProjectName,
          ProjectKey: vm.popup.data.ProjectKey,
          CreateDate: vm.popup.data.CreateDate,
          UpdateDate: vm.$moment().format('DD/MM/YYYY'),
          Info: vm.popup.data.Info,
          SendToCustomer: vm.popup.data.SendToCustomer,
          SendToInspectors: vm.popup.data.SendToInspectors,
          SendToContractors: vm.popup.data.SendToContractors,
          AddedUsers: vm.popup.data.AddedUsers,
          Pages: vm.popup.data.Pages ? vm.popup.data.Pages : null
        };

        //alert(JSON.stringify(item))
        diariesRef.child(vm.popup.data['.key']).set(item).then((snap) => {
          vm.loadDiaries();
        });

        if (item.AddedUsers) {
          var keys = Object.keys(item.AddedUsers);
          for (var u = 0; u < keys.length; u++) {
            let key = keys[u];
            let user = item.AddedUsers[key]
            if (!user.IsConfirmed) {
              var msg = {
                CreateDate: vm.$moment().format('DD/MM/YYYY'),
                DiaryKey: vm.popup.data['.key'],
                IsConfirmed: false,
                SenderName: vm.$root.user.FullName,
                SenderKey: vm.$root.user['.key'],
                Text: vm.$root.user.FullName + ' מבקש לצרף אותך ליומן',
                ToUserKey: user.UserKey,
                Type: 'אישור',
              }
              messagesRef.push(msg);
            }
          }
        }
      }
    }
  }

</script>
<style>
  .cardDiaryMobile {
    width: 100% !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .cardDiary {
    color: #fff;
    border-radius: 5px;
    margin: 5px;
    width: 300px;
    height: 210px !important;
    float: right;
    /*background-color: green;*/
    cursor: pointer;
    /*border: 2px solid #fff;*/
    opacity: 0.85;
    padding: 10px;
  }

    .cardDiary > div.container {
      height: 100%;
    }

    .cardDiary:hover {
      border: 2px solid #F7941D;
      opacity: 1.0;
    }

  .btnHvr {
    opacity: 0.0;
    font-size: 20px;
    /*padding-top: 20px;*/
  }

  .cardDiary:hover .btnHvr {
    opacity: 1.0;
  }

  .cardDiary img {
    /*height: 125px;*/
    width: 100px;
    height: 75px;
    border-radius: 5px;
  }

  .container.grid-list-lg {
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// Diaries.vue?a8d0fbc0